import { useApiAWS } from '@/composables/useApi'


const apiAws = useApiAWS()

// eslint-disable-next-line import/prefer-default-export
export function UploadVideoService() {
  this.mediaConvert = function (params) {
    return new Promise((resolve, reject) => {
      try {
        apiAws.post('/media-convert', params)
          .then(res => {
            resolve(res.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }

  this.monitorarConversao = function (JobId) {
    return new Promise((resolve, reject) => {
      try {
        apiAws.get(`/job/${JobId}`)
          .then(res => {
            resolve(res.data)
          })
      } catch (error) {
        reject(error)
      }
    })
  }
}
